/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from "prop-types";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import ReactTable from "react-table";
import {formatUrl} from "../../../_helpers/urlFormat.helper";
import config from "../../../config";
import axiosClient from "../../../_helpers/http.helper";
import urlHelper from "../../../_helpers/url.format.helper";
import {Button} from "@pearson-components/elements-sdk/build/dist.elements-sdk";

export default class PrintCollections extends React.Component {

    static propTypes = {
        collections: PropTypes.object.isRequired,
        selectedData: PropTypes.object.isRequired,
        togglePrintRow: PropTypes.func.isRequired,
        togglePrintAll: PropTypes.func.isRequired,
        selectAll: PropTypes.object.isRequired,
        updateShareModalData: PropTypes.func.isRequired,
        isPending:PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            collections: [],
            loading: true
        };
    }


    async componentDidMount() {
        const initialCollections = this.props.collections.items;
        this.setState({
            loading: true
        });
        if (!this.props.isPending) {
            const collectionIdsList = [];
            initialCollections.forEach(item => {
                collectionIdsList.push(item.collection.collectionId);
            });
            let collectionLastUpdatedDate;
            await this.getSendToPrinterDate(collectionIdsList).then(result => {
                initialCollections.map(item => {
                    collectionLastUpdatedDate = result.data[item.collection.collectionId];
                    if (collectionLastUpdatedDate) {
                        item.collection.lastSendToPrintDate = result.data[item.collection.collectionId];
                    }
                });
            });
        } else {
            initialCollections.map(item => {
                item.collection.lastSendToPrintDate = '';
            });
        }
        this.setState({
            loading: false
        }, () => {
            !this.state.loading && this.setState({ collections: initialCollections });
        });  
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.collections.items !== prevProps.collections.items) {
            this.setState({
                loading: true
            });
            const newCollections = this.props.collections.items.filter(item => !prevProps.collections.items.includes(item));
            if (!this.props.isPending) {
                const collectionIdsList = [];
                newCollections.forEach(item => {
                    collectionIdsList.push(item.collection.collectionId);
                });
                let collectionLastUpdatedDate;
                collectionIdsList.length > 0 && await this.getSendToPrinterDate(collectionIdsList).then(result => {
                    newCollections.map(item => {
                        collectionLastUpdatedDate = result.data[item.collection.collectionId];
                        if (collectionLastUpdatedDate) {
                            item.collection.lastSendToPrintDate = collectionLastUpdatedDate;
                        }
                    });
                });
            } else {
                newCollections.map(item => {
                    item.collection.lastSendToPrintDate = '';
                });
            }
            this.setState({ collections: [...this.state.collections, ...newCollections], loading: false });
        }
    }

    getSendToPrinterDate = (collectionIds) => {

        const getSendToPrinterDateUrl = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.getSendToPrinterDates,
        );

        return axiosClient.post(getSendToPrinterDateUrl, collectionIds);
    };

    render() {
        const columns = [
            {
                Header: () => {
                    return (
                        <div className="pe-checkbox" onClick={this.props.togglePrintAll}>
                            <input
                                type="checkbox"
                                id="checkboxInput"
                                value="1"
                                checked={this.props.selectAll}
                                onChange={() => {
                                }}
                            />
                            <span>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    className="pe-icon--check-sm-18"
                                >
                                    <use xlinkHref="#check-sm-18"/>
                                </svg>
                            </span>
                        </div>
                    );
                },
                Cell: row => (
                    <div
                        className="pe-checkbox"
                        onClick={() => {
                            this.props.togglePrintRow(row.original.collection);
                        }}
                    >
                        <input
                            type="checkbox"
                            id="checkboxInput"
                            checked={
                                !!this.props.selectedData[row.original.collection.collectionId]
                            }
                            onChange={() => {
                            }}
                        />
                        <span>
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                className="pe-icon--check-sm-18"
                            >
                                <use xlinkHref="#check-sm-18"/>
                            </svg>
                        </span>
                    </div>
                ),
                width: 50
            },
            {
                Header: "Title",
                accessor: "collection.title",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <a href={formatUrl(config.printAdmin.baseUrl, row.original.collection.collectionId)}>{row.original.collection.title}</a>
                    </div>);
                }
            },
            {
                Header: "ISBN",
                accessor: "customISBN.isbn",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.customISBN.isbn}</div>
                        <div>{row.original.customISBN13}</div>
                    </div>);
                }
            },
            {
                Header: "Pkg ISBN",
                accessor: "bundleISBN13",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.bundleISBN13 ? row.original.bundleISBN13 : "N/A"}</div>
                    </div>);
                }
            },
            {
                Header: "Submitted",
                accessor: "createDate",
                Cell: row => {
                    return (<span>
                        {row.original.createDate ? moment(row.original.createDate)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,
            },
            {
                Header: "Adopter",
                accessor: "adopterFirstName",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.adopterFirstName + " " + row.original.adopterLastName}</div>
                        <div>{row.original.school}</div>
                    </div>);
                }
            },
            {
                Header: "Enroll",
                id: "saleableQty",
                accessor: d =>
                    Number.parseInt(d.saleableQty, 10),
                sortable: true,
                width: 75
            },
            {
                Header: "Price",
                accessor: "collection.priceModel.totalPrice",
                sortable: true,
                width: 75
            },
            {
                Header: "Class Start",
                accessor: "classStart",
                Cell: row => {
                    return (<span>
                        {row.original.classStart ? moment(row.original.classStart)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,
            },
            {
                Header: "Market",
                accessor: "collection.geo.code",
                sortable: true,
                width: 75
            },
            {
                Header: "Files Sent",
                accessor: "collection.lastSendToPrintDate",
                Cell: row => {
                    return (<div>
                        {(row.original.collection.adminProcessingStatus === "SubmittedToPrinter" || row.original.collection.adminProcessingStatus === "Canceled" && row.original.collection.lastSendToPrintDate)
                        && <div>
                            <div>{"Sent To Printer"}</div>
                            <span>
                                {row.original.collection.lastSendToPrintDate ? moment(row.original.collection.lastSendToPrintDate).format("MM/DD/YY") : ""}
                            </span>
                        </div>
                        }
                    </div>);
                },
            },
            {
                Header: "Share",
                Cell: row => {
                    return (<div>
                        <Button type="submit" btnType="primary" onClick={() => this.props.updateShareModalData(row.original.collection, true)}>Share</Button>
                    </div>);
                }
            }
        ];
        return (
            <div className="print-collection-container">
                <h2>Print Collections</h2>
                <div className="pe-row">
                    <div className="pe-col-12 pt-4">
                        {this.props.collections.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        this.props.collections.items.length
                                    }
                                    next={this.props.loadMore}
                                    hasMore={this.props.hasMore}
                                    loader={<LoadingIndicator/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        {!this.state.loading && <ReactTable
                                            className="-highlight"
                                            data={
                                                this.state.collections
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.props.collections.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No batch details found"
                                            getTrProps={() => {
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                    }
                                                };
                                            }}
                                        />}
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/PrintCollections.js